import React from 'react';
import { cn } from '../../lib/utils';

export function Avatar({ src, alt, size = 44, className, ring = true }) {
  return (
    <img
      src={src}
      alt={alt}
      loading="lazy"
      style={{ width: size, height: size }}
      className={cn(
        'rounded-full object-cover bg-slate-200',
        ring && 'ring-2 ring-white',
        className
      )}
    />
  );
}

// Overlapping avatars to convey people/trust at a glance.
export function AvatarGroup({ people = [], size = 44 }) {
  return (
    <div className="flex items-center" data-testid="avatar-group">
      {people.map((p, i) => (
        <div key={i} style={{ marginLeft: i === 0 ? 0 : -size * 0.32 }}>
          <Avatar src={p} alt="participante" size={size} />
        </div>
      ))}
    </div>
  );
}
